import { Building2, Plus } from 'lucide-react'
import { Button } from '@/shared/components/ui/button'

interface OrganizationEmptyStateProps {
  onCreate: () => void
}

export function OrganizationEmptyState({ onCreate }: OrganizationEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-card border border-dashed border-line bg-panel p-10 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-brand-soft text-brand">
        <Building2 className="h-7 w-7" />
      </div>
      <h2 className="mt-5 font-serif text-2xl font-normal text-ink">
        Aún no has creado tu organización
      </h2>
      <p className="mt-2 max-w-md text-sm text-ink-muted">
        Crea tu organización en TecoPOS para comenzar a gestionar negocios, servicios y
        facturación desde un solo lugar.
      </p>
      <Button onClick={onCreate} variant="primary" className="mt-6">
        <Plus className="h-4 w-4" />
        Crear mi organización
      </Button>
    </div>
  )
}
